import { addIndex, map, defaultTo, reduce, pathOr, assocPath,filter, forEach } from "ramda";


/* A HOF for Ramda map, that produces an indexed map.
 * Lint barfs with errors if there is no index.
 * Regular Ramda map doesn't provide an index
 */
const mapIndexed = addIndex(map);

const forEachIndexed = addIndex(forEach)


const filterIndexed = addIndex(filter);


/*
 * This interface provides the values that are to be constructed by LD. LD is like MiB :)
 * Hence its named short.
 *
 * @param { from    } args from is an array that says the path of the data
 * @param { to      } args to is an array that says the path to place the value
 * @param { ov      } args ov is a string that overrides the value found
 * @param { df      } args df is a default that provides an alternative default value. If this isn't provided
 *                    then we use ''
 */
export interface VisualPayloadMappings {
  from: string[];
  to: string[];
  ov?: any;
  df?: string | "";
}

/*
 * LD takes the data sources and the fields that are to be mapped to a new object.
 * It gets the  from field values and applies them to a new shallow object with just that object
 * A reducer runs to build all them to one object.
 *
 * A short name, yeah.
 *
 * @param { from    } args from is an array that says the path of the data
 * @param { to      } args to is an array that says the path to place the value
 * @param { ov      } args ov is a string that overrides the value found
 * @param { df      } args df is a default that provides an alternative default value. If this isn't provided
 *                    then we use ''
 */

const LD = (oneData: any, fields: VisualPayloadMappings[]) => {
  const basic = (data: any, paths: any) => {
    const { from, to, df, ov } = paths;
    const dfv = defaultTo("")(df);
    return assocPath(to, defaultTo(pathOr(dfv, from, oneData))(ov), data);
  };
  return reduce(basic, {}, fields);
};
export { LD, mapIndexed, filterIndexed, forEachIndexed };
